import { Page, withLazyErrorBoundary, } from '@office-start/office-home-app-shared';
import React, { lazy } from 'react';
import { appbarConnectorService } from '../AppHostPage/AppHostPage';
var AppGalleryLazy = withLazyErrorBoundary(lazy(function () {
    return import(
    /* webpackChunkName: "app-gallery" */ '@office-start/app-gallery-component');
}), 'AppGallery');
export var AppGalleryPage = function () {
    var installModuleProps = {
        appFilter: 'Office',
        componentArea: 'AppList',
        showInstallButton: true,
        showConsumerUpsell: true,
        launchDime: undefined,
    };
    /**
     * Callback for when the user clicks on a metaOS app link in apps module
     */
    var appClickCallback = function (clickTime, isAppRunning) {
        appbarConnectorService.onAppButtonClick(clickTime, isAppRunning);
    };
    return (React.createElement(Page, { name: "AppGallery" },
        React.createElement(AppGalleryLazy, { installButtonProps: installModuleProps, setAppClickTime: appClickCallback })));
};
//# sourceMappingURL=AppGalleryPage.js.map